import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withResolvePaths } from "../../withResolvePaths";
import { ControlDependency } from "../../withRuntimeDependencies";
import { withViewModelSelect } from "../../withViewModelSelect";

import { Highlight } from "./Highlight";

interface HighlightContainerProps {
    dependencies?: ControlDependency[];
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: HighlightContainerProps) => {
    const { dependencies = [], viewModelSelect } = ownProps;

    for (const dependency of dependencies) {
        if (dependency.valueName == undefined) {
            continue;
        }
        const error = viewModelSelect.customFieldValueOrUndefined(state, dependency.path, dependency.valueName)?.[0];

        if (error) {
            return { error: error };
        }
    }

    return {};
};

export const HighlightContainer = withResolvePaths(withViewModelSelect(connect(mapStateToProps)(Highlight)));
